export default function () {
  if (document.getElementById('adaf-app')) {
    import(
      /* webpackChunkName: "adaf-vue-app" */ '@organisms/adaf/main'
    );
  }
}
